package com.kinoshazam.di

import org.koin.dsl.module

fun authModule() = module {

}
